import { Sounds } from '../../sounds';
import { TutorialSteps } from '../../prefabs/game/Tutorial';
import {Level, LevelMapName, LevelName} from './level';

export const Level11: Level = {
  id:LevelName.Level11,
  //smash levels are how many crates need to be smashed to reach X star goals
  smashLevels:{
    smashLevels: [50,75,100]
  },
  //target score is how many crates need to be smashed to unlock the next level
  targetScore:50,
  levelMap:LevelMapName.Level11,
  levelBackground:"bg-ice.jpg",
  gameplayBackground:"gameplay-ice.png",
  levelBackgroundAtlas:"game-ice",
  friction:0.995,
  lives: 3,
  bumperDownKey:"bumper-down-ice.png",
  tutorialStep:[TutorialSteps.None],
  arrowColor:0x334040,
  bgMusic:Sounds.Track.IceMusicLoop
}
